import { Trans, useTranslation } from 'react-i18next';
import kitopiCoinSmall from '@/assets/images/coin.svg';
import { useCurrency } from '@/context/CurrencyContext/CurrencyContext';
import formatNumber from '@/utils/formatNumber';
import styles from './Rewards.module.scss';

interface Props {
  isLoading: boolean;
  estimatedCashback: number;
  signupBonusEligible: boolean;
}

export const Rewards = ({ isLoading, estimatedCashback, signupBonusEligible }: Props) => {
  const { t } = useTranslation();
  const { currencySymbol } = useCurrency();

  if (estimatedCashback === 0) {
    return null;
  }

  return (
    <div className={styles.rewardsMessage} data-testid="rewards">
      <div className={styles.rewardsIcon}>
        <img src={kitopiCoinSmall} alt={t('rewards.kitopiCoinSmall')} />
      </div>
      <div className={styles.rewardsText}>
        <span className={styles.rewardsLine} data-testid="cashback-amount">
          <Trans
            key={`${String(isLoading)}-${String(signupBonusEligible)}`}
            i18nKey={signupBonusEligible ? 'rewards.earnWithSignupBonus' : 'rewards.earnWithOrder'}
            t={t}
            components={{
              amount: (
                <span
                  data-testid="estimated-cashback"
                  className={`${isLoading ? styles.skeleton : ''}`}
                >
                  {formatNumber(estimatedCashback)}
                </span>
              ),
            }}
            values={{ currency: currencySymbol }}
          />
        </span>
        <span className={styles.rewardsNote} data-testid="rewards-exclusion">
          {t('rewards.excludesTobacco')}
        </span>
      </div>
    </div>
  );
};
